import React, { useState } from 'react';

const ArticleCard = ({ article, showFullText = false, alwaysExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(alwaysExpanded);

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="article-card">
      <div className="article-header">
        <h3 className="article-title">
          {article.url ? (
            <a 
              href={article.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="article-title-link"
            >
              {article.title}
              <i className="fas fa-external-link-alt"></i>
            </a>
          ) : (
            article.title
          )}
        </h3>
        
        <div className="article-meta">
          {article.author && (
            <div className="article-author">
              <i className="fas fa-user"></i>
              <span>By {article.author}</span>
            </div>
          )}
          
          {article.source && (
            <div className="article-source">
              <i className="fas fa-newspaper"></i>
              <span>{article.source}</span>
            </div>
          )}
          
          {article.date && (
            <div className="article-date">
              <i className="fas fa-calendar"></i>
              <span>{formatDate(article.date)}</span>
            </div>
          )}
        </div>
      </div>

      {article.image && (
        <div className="article-image-container">
          <img 
            src={article.image}
            alt={article.title}
            className="article-image"
          />
        </div>
      )}

      {article.summary && (
        <div className="article-summary">
          <p>{article.summary}</p>
        </div>
      )}

      {showFullText && article.full_text && (
        <div className="article-content">
          {!alwaysExpanded && (
            <button 
              className="expand-toggle"
              onClick={toggleExpanded}
              aria-expanded={isExpanded}
            >
              <span>{isExpanded ? 'Hide' : 'Show'} Full Article</span>
              <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`}></i>
            </button>
          )}
          
          {(isExpanded || alwaysExpanded) && (
            <div className="article-full-text">
              <div className={`article-text-content ${alwaysExpanded ? 'full-page' : ''}`}>
                {article.full_text}
              </div>
            </div>
          )}
        </div>
      )}

      {article.url && (
        <div className="article-actions">
          <a 
            href={article.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="read-source-btn"
          >
            Read at Source
            <i className="fas fa-external-link-alt"></i>
          </a>
        </div>
      )}
    </div>
  );
};

export default ArticleCard;